import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogConfirmData {
  /** i18n-Key für den Titel */
  title: string;
  /** i18n-Key für die Nachricht */
  message: string;
  /** i18n-Key für den Bestätigen-Button (default: "confirm") */
  confirmLabel?: string;
  /** Material-Farbe des Bestätigen-Buttons (default: "primary") */
  confirmColor?: 'primary' | 'accent' | 'warn';
}

/**
 * Generischer Ja/Nein-Bestätigungsdialog. Schließt mit `true` (bestätigt) oder
 * `false`/`undefined` (abgebrochen). Alle Texte sind i18n-Keys.
 */
@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmData
  ) {}
}
